// extracted by mini-css-extract-plugin
export default {"textArea":"OrderReview_textArea__P1L6-"};